import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, onMounted, provide, onUnmounted } from 'vue';
import { useRoute, useRouter } from 'vue-router/composables';

import {
  NavBar,
  ContextColorProvider,
  Tabs,
  TabList,
  Tab
} from '@warrenbrasil/nebraska-web';
import { HeroContainer } from '@/modules/common/components/Hero';
import { BackButton } from '@/modules/common/components/buttons';
import { ShowMoneyToggleButton } from '@/modules/common/components/buttons/ShowMoneyToggleButton';
import {
  About,
  Allocation,
  Orders,
  Performance,
  PortfolioHero
} from './components';

import { IndexPortfolioTabsIndexes } from './types';
import { WarrenSession } from '@/modules/common/services/session';


export default /*#__PURE__*/_defineComponent({
  __name: 'IndexPortfolio',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const isLoading = ref(false);
const hasError = ref(false);
const currentTabIndex = ref(IndexPortfolioTabsIndexes.Performance);

const portfolioId = computed(() => {
  const { portfolioId } = route.params;

  return portfolioId;
});

provide('portfolioId', portfolioId);

const handleGoBackClick = () => {
  router.replace({ name: 'wealth' });
};

const onChangeTab = (selectedTabIndex: IndexPortfolioTabsIndexes) => {
  currentTabIndex.value = selectedTabIndex;
};

onMounted(async () => {
  const { tab } = route.query;
  if (tab === 'orders') {
    currentTabIndex.value = IndexPortfolioTabsIndexes.Orders;
  }
});

onUnmounted(() => {
  WarrenSession.remove('warren.indexPortfolio.filterOption');
});

return { __sfc: true,route, router, isLoading, hasError, currentTabIndex, portfolioId, handleGoBackClick, onChangeTab, NavBar, ContextColorProvider, Tabs, TabList, Tab, HeroContainer, BackButton, ShowMoneyToggleButton, About, Allocation, Orders, Performance, PortfolioHero, IndexPortfolioTabsIndexes }
}

})